import React from 'react';
import { alpha, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { Language } from '@/core';
import { LanguagePicker, LanguageTypes } from '@/features';

type FormLanguageTextFieldControllerProps = {
  label: string;
  controllerName: string;
  helperText: string;
  selectedLanguage: LanguageTypes;
  setSelectedLanguage: (selectedLanguage: LanguageTypes) => void;
  error?: boolean;
  errorText?: string;
  fieldOnBlur?: () => void;
};

export const FormLanguageTextFieldController = ({
  label,
  controllerName,
  helperText,
  selectedLanguage,
  setSelectedLanguage,
  error,
  errorText,
  fieldOnBlur,
}: FormLanguageTextFieldControllerProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field: { value, onChange, onBlur, ...field } }) => {
        const currentValue: string = value ? value[selectedLanguage as keyof Language] : '';
        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          onChange({
            ...value,
            [selectedLanguage]: newValue,
          });
        };
        return (
          <TextField
            {...field}
            value={currentValue}
            onBlur={() => {
              onBlur();
              fieldOnBlur?.();
            }}
            onChange={handleInputChange}
            label={label}
            multiline
            rows={3}
            fullWidth
            error={error}
            helperText={error && errorText ? errorText : helperText}
            InputProps={{
              endAdornment: (
                <LanguagePicker currentLanguage={selectedLanguage} onChange={setSelectedLanguage} />
              ),
            }}
            FormHelperTextProps={{
              sx: { color: alpha('#000', 0.38) },
            }}
          />
        );
      }}
    />
  );
};
